import { render, staticRenderFns } from "./SanarMap.vue?vue&type=template&id=9789bc1c"
import script from "./SanarMap.vue?vue&type=script&lang=js"
export * from "./SanarMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports